window._ = require('./bootstrap')
window.pdfjsLib = require('pdfjs-dist')
require('pdfjs-dist/build/pdf.worker')
require('/plugins/jquery-ui/jquery-ui.min')
require('lity')
window.introJs = require('intro.js')
require('/dash/assets/plugins/bootstrap/popper.min')
require('bootstrap')
require('/dash/assets/js/custom')
require('icheck')
//require('select2/dist/js/select2.full.min')
window.datepicker = require('bootstrap-datepicker')
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.es.min')

require('bootstrap-fileinput')
window.accounting = require('/plugins/accounting.min')
window.toastr = require('toastr')
require('/AdminLTE/plugins/pace/pace.min')
require('/js/jquery-validation-1.16.0/dist/jquery.validate.min')

require('jquery-validation')
require('jquery-validation/dist/additional-methods')
window.moment = require('moment')
require('moment/locale/es')
require('moment-timezone/builds/moment-timezone-with-data.min')
require('eonasdan-bootstrap-datetimepicker')
require('daterangepicker')
// window.CKEDITOR = require('ckeditor4')
require('/plugins/sweetalert/sweetalert.min')
